export default __webpack_public_path__ + "static/media/spinner.bdd29882.gif";